<template>
  <div class="article" v-if="article">
    <div class="article-title">{{ article.title }}</div>
    <div class="article-time">更新时间：{{ article.update_time }}</div>
    <hr>
    <div v-html="article.info"></div>
  </div>
  <el-empty v-else description="暂无文档内容"/>
</template>

<script>
  import apis from "@/api/apis";
  export default {
    name: "DocumentArticle",
    props:{
      documentId:String
    },
    data() {
      return {
        article: null,
      }
    },
    mounted() {
      this.getArticle()
    },
    methods:{
      getArticle(){
        const params = this.$route.params
        if(!params.documentId){
          return
        }
        apis.document.getArticle({document_id: params.documentId}).then(res => {
          this.article = res.data
          document.getElementById('title').innerHTML = this.article.title + ' - 微客云集'
        })
      }
    },
    watch:{
      '$route.params.documentId'(){
        this.getArticle()
      }
    }
  }
</script>

<style scoped lang="scss">
  .article{
    background: #fff;
    padding: 24px;
      .article-title{
        font-size: 32px;
        font-weight: bold;
        color: #1E1E28;
        line-height: 45px;
      }
      .article-time{
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
      }
      hr{
        height: 1px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        margin: 24px 0;
      }
  }
  ::v-deep table{
    border-collapse: collapse;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    margin: 10px 0px;
    width: 100%;
    td{
      border-left: 1px solid #ddd;
      border-top: 1px solid #ddd;
    }
  }
</style>
